export const RUNNABLE_API_BLOCK_NAME = 'restApiBlock'
export const RUNNABLE_CODE_BLOCK_NAME = 'runnableCodeBlock'